type NPSQuestionKindObject = {
  [key: string]: {
    name: string
    color: string
  }
}

export const NPS_QUESTION_KIND_OBJECT: NPSQuestionKindObject = {
  NPS: {
    name: 'NPS',
    color: 'blue',
  },
  MULTIPLE_SELECTION_BOX: {
    name: 'Multipla escolha',
    color: 'green',
  },
  SHORT_TEXT: {
    name: 'Texto',
    color: 'cyan',
  },
  INTEGER: {
    name: 'Inteiro',
    color: 'purple',
  },
  UNKNOWN: {
    name: 'Desconhecido',
    color: 'gray',
  },
}
